
import { useState } from "react";
import Joi from "joi";
import { validateFormData } from "../../utils/validation"; 
import { asyncUserLogin } from "../../redux/user/action/authAction";
import { userLoginSuccess } from "../../redux/user/slice/userAuthSlice";
import {
  handleCatchErrors,
  successMsg,
} from "../../utils/customFn"; 
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.userAuth);

  const [formData, setFormData] = useState({ email: "", password: "" });
  const [formErrors, setFormErrors] = useState({});
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Define the validation schema for the form
    const validationSchema = Joi.object({
      email: Joi.string()
        .email({ minDomainSegments: 2, tlds: { allow: ["com", "org", "net"] } })
        .required()
        .messages({
          "string.email": "Please enter a valid email address.",
          "any.required": "Email is required.",
        }),
      password: Joi.string()
        .min(6)
        .required()
        .messages({
          "any.required": "Password is required.",
        }),
    });

  
    const validationResponse = await validateFormData(
      formData,
      validationSchema
    );

    // If validation fails, set the errors
    if (!validationResponse.status) {
      setFormErrors(validationResponse.errors);
      return;
    }

  
    // Dispatch asyncUserLogin as a thunk
    asyncUserLogin({ formData })
      .then((result) => {
        // If login is successful, perform the success actions
        const { token:accessToken, refreshToken } = result.data;
        dispatch(userLoginSuccess({ accessToken, refreshToken }));
        successMsg("Login Successful");
        navigate("/main-dashboard");
      })
      .catch((loginError) => {
        handleCatchErrors(loginError, navigate, setFormErrors, "/");
      });
  };

  return {
    formData,
    formErrors,
    isPasswordVisible,
    loading,
    error,
    handleChange,
    setIsPasswordVisible,
    handleSubmit,
  };
};

export default useLogin;
